export interface IContactEmail {
  id: string;
  label: string;
  email: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface IContactEmailApiModel {
  id: string;
  label: string;
  email: string;
  createdAt: string;
  updatedAt: string;
}

export default class ContactEmail implements IContactEmail {
  public readonly id: string;

  public readonly label: string;

  public readonly email: string;

  public readonly createdAt: Date;

  public readonly updatedAt: Date;

  constructor(
    id: string,
    label: string,
    email: string,
    createdAt: Date,
    updatedAt: Date,
  ) {
    this.id = id;
    this.label = label;
    this.email = email;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
  }

  static fromApiModel(apiModel: IContactEmailApiModel) {
    const { id, label, email } = apiModel;

    const createdAt = new Date(Date.parse(apiModel.createdAt));
    const updatedAt = new Date(Date.parse(apiModel.updatedAt));

    return new ContactEmail(id, label, email, createdAt, updatedAt);
  }

  static arrayFromApiModel(arrayApiModel: IContactEmailApiModel[]) {
    const array = arrayApiModel.map(apiModel => {
      return this.fromApiModel(apiModel);
    });

    return array;
  }
}
